import { Trademark } from '../types/Trademark'
import { austria, defaultGermany, switzerland } from './trademarks'

enum COUNTRY_ISO_CODE {
    GERMANY = 'DE',
    SWITZERLAND = 'CH',
    AUSTRIA = 'AT',
}

const prepareTrademarks = (trademarks: Trademark[]) =>
    trademarks.map(item => ({
        target: '_blank',
        rel: 'noreferrer noopener nofollow',
        width: 0,
        height: 35,
        ...item,
    }))

export const getTrademarksData = (country?: string): Required<Trademark>[] => {
    switch (country) {
        case COUNTRY_ISO_CODE.AUSTRIA:
            return prepareTrademarks(austria)
        case COUNTRY_ISO_CODE.SWITZERLAND:
            return prepareTrademarks(switzerland)
        default:
            return prepareTrademarks(defaultGermany)
    }
}
